import Component, { mixins } from 'vue-class-component'
import { Ref, Watch } from 'vue-property-decorator'

import WithRender from './FicheRepondantUpdate.html'

import {
  MButton,
  MButtonSkin,
  MMessage,
  MMessageSkin,
  MMessageState,
  MSpinner
} from '@ulaval/modul-components'

import FicheRepondantForm, { IFicheRepondantFormPayload } from '../form/FicheRepondantForm'
import FicheRepondantService from '../FicheRepondant.service'
import CountryService from '@/modules/global/localization/country/Country.service'
import ROUTES from '@/router/ROUTES'
import { IFicheRepondantModel } from '../FicheRepondant.model'

const REF_FICHE_REPONDANT_FORM: string = 'ref[fiche-repondant-form]'

@WithRender
@Component({
  components: {
    FicheRepondantForm,
    MButton,
    MMessage,
    MSpinner
  }
})
export default class FicheRepondantUpdate extends mixins(FicheRepondantService, CountryService) {
  private ficheRepondant: IFicheRepondantModel | null = null
  private isLoadingStateActive: boolean = false
  private isSuccessStateActive: boolean = false

  private readonly MButtonSkin: object = MButtonSkin
  private readonly MMessageSkin: object = MMessageSkin
  private readonly MMessageState: object = MMessageState
  private readonly REF_FICHE_REPONDANT_FORM: string = REF_FICHE_REPONDANT_FORM

  @Ref(REF_FICHE_REPONDANT_FORM)
  private ficheRepondantFormComponent!: FicheRepondantForm | null

  @Watch('$route.params', { immediate: true })
  private onRouteParamsChange(): void {
   if (this.$route.params.idFicheRepondant) {
    this.fetchFicheRepondant()
   }
  }

  private mounted(): void {
    this.loadCountries()
  }

  private loadCountries(): void {
    this.service_countryService_fetchCountries()
  }

  private async onSubmitButtonClick(): Promise<void> {
    if (this.ficheRepondantFormComponent && this.ficheRepondant) {
      const formPayload: IFicheRepondantFormPayload | null = await this.ficheRepondantFormComponent.getFormPayload()
      
      if (formPayload) {
        this.updateFicheRepondant(formPayload)
      }
    }
  }

  private fetchFicheRepondant(): void {
    this.isLoadingStateActive = true

    this.service_ficheRepondantService_fetchById(this.$route.params.idFicheRepondant as any)
      .then((response: IFicheRepondantModel) => {
        this.ficheRepondant = response || null
      }).catch(() => {
        this.ficheRepondant = null
      }).finally(() => {
        this.isLoadingStateActive = false
      })
  }

  private updateFicheRepondant(formPayload: IFicheRepondantFormPayload): void {
    if (this.ficheRepondant) {
      this.isLoadingStateActive = true
    
      this.service_ficheRepondantService_update(
        formPayload,
        this.ficheRepondant.id
      ).then(() => {
        this.isSuccessStateActive = true
      }).finally(() => {
        this.isLoadingStateActive = false
      })
    }
  }

  private onReturnHomeButtonClick(): void {
    this.mixin_router_navigate({
      name: ROUTES.FICHE_REPONDANT_OVERVIEW,
      params: this.$route.params,
      query: this.$route.query
    })
  }
}
